// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"c6b47a80","220":"e1c632d2","641":"b66075fe","667":"91406919","788":"0b35eef6","977":"264c7fbf"}[chunkId] + ".chunk.js";
};